import React, { useMemo } from "react";
import { object, shape, string, any } from "prop-types";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import SectionHero from "./components/SectionHero";
import SectionResources from "./components/SectionResources";

const ResourcesPage = ({ page, pageProps }) => {
	const [t] = useLocale("resources");
	const { siteDomain, brandCode, customSections = [] } = pageProps;
	const { sections } = page;

	const list = [...sections, ...customSections];

	const sortSections = (a, b) => {
		const sectionA = a.blockOrder;
		const sectionB = b.blockOrder;
		return sectionA < sectionB ? -1 : sectionA > sectionB ? 1 : 0; // eslint-disable-line
	};

	const listModified = useMemo(() => list.sort(sortSections), [list, sortSections]);

	return (
		<>
			<PageMeta title={t("META_TITLE")} description={t("META_DESCRIPTION")}>
				<PageMeta.OGP
					title={t("META_TITLE")}
					description={t("META_DESCRIPTION")}
					url={`${siteDomain}/resources`}
				/>
				<PageMeta.Twitter
					card={t("META_TWITTER_CARD")}
					site={t("META_TWITTER_SITE")}
					creator={t("META_TWITTER_CREATOR")}
					title={t("META_TITLE")}
					description={t("META_DESCRIPTION")}
				/>
				<PageMeta.Canonical href={`${siteDomain}/resources`} />
			</PageMeta>
			<SectionHero
				title={t("TITLE")}
				description={t("DESCRIPTION")}
				brandCode={brandCode}
				items={listModified}
			/>
			{listModified.map(pageSection => (
				<SectionResources
					key={pageSection.id}
					id={pageSection.id}
					brandCode={brandCode}
					title={pageSection.name}
					items={pageSection.items}
					Component={pageSection.Component}
					{...pageSection.props}
				/>
			))}
		</>
	);
};

ResourcesPage.propTypes = {
	page: object.isRequired, // eslint-disable-line react/forbid-prop-types
	pageProps: shape({
		resources: any, // eslint-disable-line react/forbid-prop-types,
		siteDomain: string,
	}),
};

export default ResourcesPage;
